import { axiosWdw, domainEndpoint } from './axios';
import { Message, MessageHistory } from '@/models/message.model';
import { Response } from '@/models/generic-paging.model';
const endpoint = '/message';
const endpointHistory = '/message_history';
export default {
  getMessageByMessageId(messageId: number, params?: Record<string, string | number>): Promise<Message> {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + `/${messageId}`,
        params: params,
      })
        .then(response => {
          resolve(response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  async getMessageHistoryEntries(params?: object, fetchWithCredentials = true): Promise<MessageHistory[]> {
    if (!fetchWithCredentials) {
      const URL = process.env.VUE_APP_SERVER_BASE_API + '/api/v1/' + domainEndpoint() + endpointHistory;

      // Important: axios is not working to make a request without the cookie. Somehow, even when
      // providing `withCredentials: false`, it uses the cookie in production. For this specific case, we
      // use fetch API with `credentials: 'omit'`.
      const response = await fetch(URL + '?' + new URLSearchParams({ ...params, permissions: 'complete' }), {
        method: 'GET',
        credentials: 'omit', // Is needed to make the request without a cookie
      });

      return response.json();
    }

    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpointHistory,
        params: { ...params, permissions: 'complete' },
      })
        .then(response => {
          resolve(response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getMessagesByQueryParams(params?: object): Promise<Response<Message[]>> {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint,
        params: params,
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  subscribeMessage(messageid: number, params?: object) {
    return new Promise((resolve, reject) => {
      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + endpoint + `/${messageid}/subscribe`,
        params,
      })
        .then(response => {
          resolve(response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
